import './styles/index.scss';
import React from 'react';
// import ReactDOM from 'react-dom';
// import { createRoot } from 'react-dom/client';
import ReactDOM from 'react-dom/client';
import configureStore from './store/configureStore';
import getMiddlewares from './middlewares';
import App from './App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import reportWebVitals from './reportWebVitals';

const storeConfig = configureStore(getMiddlewares());

// const container = document.getElementById('root');
// const root = createRoot(container); // createRoot(container!) if you use TypeScript
const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <storeConfig.Provider store={storeConfig.store}>
    <App />
  </storeConfig.Provider>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
